import { useQuery } from '@tanstack/react-query'

import { NotificationQuery } from './NotificationQuery'

export const userNotificationQuery: NotificationQuery = {
  getNotificationsQueryKey() {
    return ['ws', 'user', 'notificationCount']
  },

  useNotificationsQuery() {
    return useQuery<number>({
      queryKey: this.getNotificationsQueryKey(),
      queryFn: () => 0,
      staleTime: Infinity
    })
  }
}
